var React = require('react');

function BulletPointBorder (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"4.97046","y":"0.403922","width":"6.5","height":"6.5","rx":"1.25","transform":"rotate(45 4.97046 0.403922)","stroke":"black","strokeWidth":"1.5"}));
}

BulletPointBorder.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none"};

module.exports = BulletPointBorder;

BulletPointBorder.default = BulletPointBorder;
